import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";

// Platform flags from GET /config. Until loaded: private + Stripe off, so marketing/billing never flash.
let cached = null;
let pending = null;
const DEFAULTS = { private_mode: true, stripe_enabled: false };

const load = () => {
  if (!pending) {
    pending = api.get("/config")
      .then((r) => { cached = { ...DEFAULTS, ...r.data, private_mode: r.data?.private_mode !== false, stripe_enabled: r.data?.stripe_enabled === true }; return cached; })
      .catch(() => { cached = DEFAULTS; return cached; });
  }
  return pending;
};

const useFlag = (key) => {
  const [v, setV] = useState((cached || DEFAULTS)[key]);
  useEffect(() => {
    let alive = true;
    load().then((c) => alive && setV(c[key]));
    return () => { alive = false; };
  }, [key]);
  return v;
};

export const usePrivateMode = () => useFlag("private_mode");
export const useStripeEnabled = () => useFlag("stripe_enabled");
